/* This file is auto-generated by scripts/import-video-vault.js */

export const VIDEO_VAULT: {
  id: string;
  filename: string;
  title: string;
  tags: string[];
  type: "video-vault" | "weekly-idea" | "weekly-build";
  date?: string;
  description: string,
}[] = 
[
  {
    "id": "0.4867ef3819bf90.b47ffb2f4e73b",
    "filename": "Jd3xd5Dk8kw",
    "tags": [
      "ecommerce",
      "influencer",
      "blogging",
      "idea"
    ],
    "type": "video-vault",
    "title": "How to Choose The Right Side Business For You",
    "date": "",
    "description": ""
  },
  {
    "id": "0.908cbed929a9d0.f9e3c7ba21202",
    "filename": "98x5Pja6AE5",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "How to Self-publish an E-book",
    "date": "",
    "description": ""
  },
  {
    "id": "buidgeneral1",
    "filename": "lH7GaS7zZeM",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Using AI to Help Fast Track Your Side Business",
    "date": "",
    "description": ""
  },
  {
    "id": "name",
    "filename": "JlGWnr8Q0Fz",
    "tags": [
      "ecommerce",
      "influencer",
      "blogging",
      "build"
    ],
    "type": "video-vault",
    "title": "How to Choose a Winning Business Name and Domain",
    "date": "",
    "description": ""
  },
  {
    "id": "name2",
    "filename": "rZYbKiqlyQB",
    "tags": [
      "blogging",
      "build"
    ],
    "type": "video-vault",
    "title": "Crafting the Perfect Name for Your Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "validate1",
    "filename": "5FbaHVxJrTg",
    "tags": [
      "ecommerce",
      "influencer",
      "blogging",
      "validate"
    ],
    "type": "video-vault",
    "title": "Gaining the Confidence to Fully Commit to Your Business Idea",
    "date": "",
    "description": ""
  },
  {
    "id": "0.c23acb56ab0d70.51ac92d4eb07c",
    "filename": "7Yn1mMFZhQW",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Launching a Successful E-Printables Business: A Beginner's Guide",
    "date": "",
    "description": ""
  },
  {
    "id": "ideablog",
    "filename": "uAgh70gAd4L",
    "tags": [
      "blogging",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Carving a Unique Niche in Personal Finance Blogging",
    "date": "",
    "description": ""
  },
  {
    "id": "influenceridea",
    "filename": "P6WudBh3Wuw",
    "tags": [
      "influencer",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Fitness & Family: Creating a Mom Fitness Channel Inspired by Twins",
    "date": "",
    "description": ""
  },
  {
    "id": "amazon1",
    "filename": "2W8DLIydN61",
    "tags": [
      "ecommerce",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Amazon Success Story: How John Built a Profitable Pacifier Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.98245017648090.35b427f87903b",
    "filename": "s2KrASlRL2y",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Can You Turn Lobbying Into a Side Business",
    "date": "",
    "description": ""
  },
  {
    "id": "ecommerce2",
    "filename": "JPeVf3a1xQc",
    "tags": [
      "ecommerce",
      "build",
      "scale",
      "validate"
    ],
    "type": "video-vault",
    "title": "Starting a Micro Season Content Calendar Business",
    "date": "",
    "description": ""
  },
  {
    "id": "influencer2",
    "filename": "eMqOYoAGMAl",
    "tags": [
      "influencer",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Building an Influencer Channel For Nurses",
    "date": "",
    "description": ""
  },
  {
    "id": "blogging1",
    "filename": "jSAEJxVUWh2",
    "tags": [
      "blogging",
      "validate"
    ],
    "type": "video-vault",
    "title": "Refining Your Blog's Focus: From Self-Sustainability to Cozy Kitchen Living",
    "date": "",
    "description": ""
  },
  {
    "id": "blogging2",
    "filename": "YGXaF82hDal",
    "tags": [
      "blogging",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Creating a Latino-Focused Financial Independence Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "influencer3",
    "filename": "FMx1LYTk368",
    "tags": [
      "blogging",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Fitness Passion to Profit: Launching a Successful Content Side Biz",
    "date": "",
    "description": ""
  },
  {
    "id": "blogging3",
    "filename": "5enjauOIehd",
    "tags": [
      "blogging",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Bicoastal Blogging: Peter's Journey to a Dual Locale Retirement",
    "date": "",
    "description": ""
  },
  {
    "id": "influencer4",
    "filename": "HVkG71xm9tV",
    "tags": [
      "blogging",
      "idea",
      "validate"
    ],
    "type": "video-vault",
    "title": "Exploring Monetization Opportunities in Colleges",
    "date": "",
    "description": ""
  },
  {
    "id": "blogging4",
    "filename": "viNWvtaj9nP",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Building a Japanese Food Blog with Jess",
    "date": "",
    "description": ""
  },
  {
    "id": "ecommideagen1",
    "filename": "3yptXsXcALB",
    "tags": [
      "idea",
      "influencer",
      "ecommerce"
    ],
    "type": "video-vault",
    "title": "Grant Helps Glen Discover an Exciting Youtube Side Biz ",
    "date": "",
    "description": ""
  },
  {
    "id": "diy1",
    "filename": "G04lxmJ7IZU",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Brady's Side Business is on Track to Bring in $500 this month ",
    "date": "",
    "description": ""
  },
  {
    "id": "0.c2d1eede839fe0.cc976877e5b5a",
    "filename": "C5NHwhjoewb",
    "tags": [
      "idea",
      "content",
      "blogging"
    ],
    "type": "video-vault",
    "title": "First Year Experience Content Curator",
    "date": "",
    "description": ""
  },
  {
    "id": "0.e61417d0a52cd0.8b4513438cf33",
    "filename": "S98di1bPNSQ",
    "tags": [
      "idea"
    ],
    "type": "video-vault",
    "title": "How Much Can You Make From Consulting? ",
    "date": "",
    "description": ""
  },
  {
    "id": "0.8346f9dc2f9780.36ea6c7dd3058",
    "filename": "2z8y7KpQXqi",
    "tags": [
      "idea"
    ],
    "type": "video-vault",
    "title": "Grant helps Ryan Find His Niche ",
    "date": "",
    "description": ""
  },
  {
    "id": "0.085bd57bee340.b922d30f26eaa",
    "filename": "a19fJyPNwYs",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Tunnel Vision is Killing my Progress",
    "date": "",
    "description": ""
  },
  {
    "id": "0.9e77525e1c1970.14bcf667d2c97",
    "filename": "rySdBI3zujf",
    "tags": [
      "blogging",
      "validate"
    ],
    "type": "video-vault",
    "title": "Grant gets into the weeds of blogging with Claire",
    "date": "",
    "description": ""
  },
  {
    "id": "amazonscale2",
    "filename": "z360rNwDwSo",
    "tags": [
      "ecommerce",
      "idea",
      "scale"
    ],
    "type": "video-vault",
    "title": "Using a Youtube Channel to Drive Ecommerce Sales",
    "date": "",
    "description": ""
  },
  {
    "id": "ecommideagen2",
    "filename": "OkrSzceRD5F",
    "tags": [
      "ecommerce",
      "idea"
    ],
    "type": "video-vault",
    "title": "Combining Amazon FBA and a Youtube Channel for the Perfect Go-to-market Strategy",
    "date": "",
    "description": ""
  },
  {
    "id": "0.63d181d234c110.09543efc72e5c",
    "filename": "3X2BdfVeSBF",
    "tags": [
      "idea"
    ],
    "type": "video-vault",
    "title": "Grant's encouragement - Don't sell yourself short",
    "date": "",
    "description": ""
  },
  {
    "id": "0.5e9b84683c1c0.57df0400212ac",
    "filename": "72XpVcV7zpq",
    "tags": [
      "scale",
      "blogging"
    ],
    "type": "weekly-build",
    "title": "How to Market a Book & Product ",
    "date": "2/28/2024",
    "description": ""
  },
  {
    "id": "0.62f408d7611810.6dc198b1d51dd",
    "filename": "mM1xw0751ip",
    "tags": [
      "scale",
      "blogging"
    ],
    "type": "video-vault",
    "title": "How to Market or Launch Your Book",
    "date": "2/28/2024",
    "description": ""
  },
  {
    "id": "amazonscale",
    "filename": "61rr7S4KzAd",
    "tags": [
      ""
    ],
    "type": "weekly-idea",
    "title": "Grant Helps Logan go from $5k/month in profit to $20k/month ",
    "date": "3/4/2024",
    "description": ""
  },
  {
    "id": "0.e7e85fd1bb9060.95a4dc3f1abce",
    "filename": "sODJU10pbMN",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Organic Growth on Etsy",
    "date": "",
    "description": ""
  },
  {
    "id": "0.57a78c4bd66d40.cb56f012ab82e",
    "filename": "Q3LnNT3A2bs",
    "tags": [
      "ecommerce"
    ],
    "type": "video-vault",
    "title": "How to start an E-printables side business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.1842df0967da30.a3a914e17aa4e",
    "filename": "4GjZlhjbCeF",
    "tags": [
      "idea",
      "validate",
      "build"
    ],
    "type": "video-vault",
    "title": "How to Build Confidence to Commit to an Idea",
    "date": "",
    "description": ""
  },
  {
    "id": "blogname1",
    "filename": "T6Q92B6Xm8i",
    "tags": [
      "idea",
      "blogging"
    ],
    "type": "video-vault",
    "title": "How to Pick the Perfect Name for a Money-based Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "domain1",
    "filename": "3PtZIO2V8wn",
    "tags": [
      "idea",
      "blogging",
      "ecommerce"
    ],
    "type": "video-vault",
    "title": "How to pick a winning name (and domain!)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.fe8fc68ac8a170.df77b704a2978",
    "filename": "RfBfv8xjboo",
    "tags": [
      "blogging",
      "ecommerce"
    ],
    "type": "video-vault",
    "title": "Writing your own Ebook & ghost writing",
    "date": "",
    "description": ""
  },
  {
    "id": "0.fd821db8f4f9f0.a7b2b10a8e15e",
    "filename": "xW22gO2uDrX",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Tips for Recent College Grads (W2)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f6a841593181b0.4ecaa23fa0f5b",
    "filename": "PULtxmMyxi6",
    "tags": [
      "financial independence",
      "idea"
    ],
    "type": "video-vault",
    "title": "Real Estate Investing (BRRR) Resources",
    "date": "",
    "description": ""
  },
  {
    "id": "0.b536401aa9feb0.0139eff58ae",
    "filename": "GYLKgC0deXx",
    "tags": [
      "idea",
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Picking the right business blueprint to explore",
    "date": "",
    "description": ""
  },
  {
    "id": "0.0344bd6e96910.e87795d4158ce",
    "filename": "Rj0oiLxIJt0",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Brady's Experience in the FIpreneur Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.675ca718dff40.72440dfadef17",
    "filename": "ocv8lhMph6e",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Jess' Experience in the FIpreneur Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f619ffc602bf60.18e5a33970262",
    "filename": "t3xViMOPRad",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "John's Experience in the FIpreneur Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.a41a3295cc3220.21113d3bdde58",
    "filename": "ymInqVw6rF0",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Claire's Experience in the FIpreneur Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.50a749ab580910.111104c14e913",
    "filename": "WIem09WG8Re",
    "tags": [
      "idea",
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Robert Finds an Idea to pursue while Nursing",
    "date": "1/29/2024",
    "description": ""
  },
  {
    "id": "0.70a72c622283a0.b84cadb3f56ba",
    "filename": "oal2nF1n6Yk",
    "tags": [
      "idea",
      "scale"
    ],
    "type": "weekly-idea",
    "title": "Grant's Inner Circle Advice For Brady",
    "date": "",
    "description": ""
  },
  {
    "id": "0.907266b1330670.9f06ab6e70e8a",
    "filename": "tNxJMxiAKoI",
    "tags": [
      "idea",
      "validate",
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Grant's Inner Circle Advice For Claire",
    "date": "",
    "description": ""
  },
  {
    "id": "0.726cb8fa30e570.36833bb7d2bd1",
    "filename": "xq99kAG5G5S",
    "tags": [
      "idea",
      "validate",
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Grant's Inner Circle Advice For Jess",
    "date": "",
    "description": ""
  },
  {
    "id": "0.8f6c6797078d40.3e45690f54d3f",
    "filename": "NrgVnd5AUn9",
    "tags": [
      "blogging"
    ],
    "type": "weekly-build",
    "title": "Watch Grant give Jess Live Feedback on her Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "amaznvalidate",
    "filename": "jTyq212J1bp",
    "tags": [
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "Detailed Validation for Amazon FBA",
    "date": "",
    "description": ""
  },
  {
    "id": "amzn",
    "filename": "gBdU0wBD4Mg",
    "tags": [
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "High Level Validation for Ecommerce Products",
    "date": "",
    "description": ""
  },
  {
    "id": "scaleblog",
    "filename": "VpyO1pLxwU3",
    "tags": [
      "blogging"
    ],
    "type": "weekly-build",
    "title": "Building a $1m+ Food Blog with Jess",
    "date": "",
    "description": ""
  },
  {
    "id": "0.e0ef94a38d8540.6ca2fb6410d34",
    "filename": "pVmnNIpo8cd",
    "tags": [
      "ecommerce",
      "build"
    ],
    "type": "weekly-idea",
    "title": "Matt R. Introduces Jammin' Jimmie",
    "date": "",
    "description": ""
  },
  {
    "id": "contentplan",
    "filename": "pVmnNIpo8cd",
    "tags": [
      "blogging",
      "build"
    ],
    "type": "weekly-idea",
    "title": "Grant's Advice on Content Calendar Planning",
    "date": "",
    "description": ""
  },
  {
    "id": "0.0191e31bb995c0.46fdc8579dcd6",
    "filename": "Qi4tR38Wjt4",
    "tags": [
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Adelaide + Fitness TikTok",
    "date": "",
    "description": ""
  },
  {
    "id": "0.ec1e2756e45f70.0865e5450cbe1",
    "filename": "4LBVu2bi4WU",
    "tags": [
      "blogging"
    ],
    "type": "weekly-build",
    "title": "Jess + VeganJapanese Blog Update",
    "date": "",
    "description": ""
  },
  {
    "id": "0.7ae4373d3f0e20.5254fc41aa2ec",
    "filename": "jmy9qRyOOFG",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Mark Finds an Opportunity",
    "date": "",
    "description": ""
  },
  {
    "id": "0.bd3493d142e970.d5e97afd96f0f",
    "filename": "XiK8mNMxQdJ",
    "tags": [
      "blogging",
      "scale"
    ],
    "type": "weekly-idea",
    "title": "Claire + Blog Growth",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f418a3398afc90.b5dadb2856245",
    "filename": "jfzLQMvbxAK",
    "tags": [
      "financial independence"
    ],
    "type": "weekly-idea",
    "title": "Cahill + FI & Life Transition",
    "date": "",
    "description": ""
  },
  {
    "id": "0.1ef558be6e00c0.cb106ec07f718",
    "filename": "e6l86he9yG7",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Casey + Unique take on Planners (ADHD)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.fb45065d40b5c0.2967503264417",
    "filename": "BzSD6zEpEbJ",
    "tags": [
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Yemi + Midlifer Money Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "0.cb62f232819a80.bd30acbe6aff1",
    "filename": "fMsk3973t7r",
    "tags": [
      "financial independence",
      "scale"
    ],
    "type": "weekly-build",
    "title": "Antonio + Elite School Admissions",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4e61e070670bf0.d5106e4c82b67",
    "filename": "GWarLqKjTpX",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "The First Hire",
    "date": "",
    "description": ""
  },
  {
    "id": "amznidea",
    "filename": "YzoYhYxVAZy",
    "tags": [
      "ecommerce",
      "scale"
    ],
    "type": "weekly-build",
    "title": "Mary Beth + Toy Dolls",
    "date": "",
    "description": ""
  },
  {
    "id": "0.eea9bcebb0feb0.6b734ca19507c",
    "filename": "lFMRMODgH4U",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Kylan + Life Pivot",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f89048fa95f480.9521d80d852b3",
    "filename": "W9T9QpDTK20",
    "tags": [
      "idea",
      "influencer"
    ],
    "type": "video-vault",
    "title": "Rachael - Dr. Mom (Update)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.5640f077e2acf0.33eb63e114547",
    "filename": "DfBfZ4Yzw9b",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Steven + Theatre (Monetizing a skill)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.26536287f18790.71d222c8d452f",
    "filename": "GbF6Kpe4xKZ",
    "tags": [
      "idea",
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Perry + Tarot Readings",
    "date": "",
    "description": ""
  },
  {
    "id": "0.97aa2180569420.48d0835d51e61",
    "filename": "MyNS9WZcpPq",
    "tags": [
      "scale",
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "Matt R. + Goated (App) Affiliate",
    "date": "",
    "description": ""
  },
  {
    "id": "0.96e1b89336ebc0.36aa99d1379a4",
    "filename": "J4vgqO6OXVq",
    "tags": [
      "idea",
      "scale",
      "financial independence"
    ],
    "type": "weekly-build",
    "title": "Lucy & Lee + Consulting Business Power Couple",
    "date": "",
    "description": ""
  },
  {
    "id": "0.abad0017cce2f0.fb3990cc7c8f4",
    "filename": "WA3onm9vbUk",
    "tags": [
      "ecommerce",
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Shavonne + STEM Kits",
    "date": "",
    "description": ""
  },
  {
    "id": "0.80a5d7a062de10.57b0085858e5b",
    "filename": "uEGSKptGNmU",
    "tags": [
      "financial independence",
      "idea"
    ],
    "type": "video-vault",
    "title": "Finding an Immediate Path to Cash",
    "date": "",
    "description": ""
  },
  {
    "id": "0.6a1e717a178a30.c136a5f931842",
    "filename": "vZZUg5Gj139",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Pat + Finance Coach",
    "date": "",
    "description": ""
  },
  {
    "id": "0.07a01b591134f0.e6e4fc40e4435",
    "filename": "x1DaNQd8Q7q",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Rachael - Inspiring New Parents",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4e84135f8109b0.2b0c1306d9507",
    "filename": "qFYlhWWJ5qo",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Alex + Virtual CFO Tools",
    "date": "",
    "description": ""
  },
  {
    "id": "0.9d8579f01a96c0.eab3d8b875d25",
    "filename": "431Wc3tDg9A",
    "tags": [
      "idea",
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Andrea + Writing a Book to Build a Niche Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.9cc5f9d7e6c670.aea673b1a0d38",
    "filename": "YDcPfpcyEFg",
    "tags": [
      "idea",
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Jess + Japanese Food Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4d9f88fff8370.139f39e14d664",
    "filename": "dVC1mfJwmm2",
    "tags": [
      "influencer",
      "blogging"
    ],
    "type": "video-vault",
    "title": "Chris, RN - Activating Social Media",
    "date": "",
    "description": ""
  },
  {
    "id": "0.df1c5702399230.4c879d00092b2",
    "filename": "u25QgRFeJ7D",
    "tags": [
      "idea",
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Mom of Twins Enters Entrepreneurial World",
    "date": "",
    "description": ""
  },
  {
    "id": "0.71681bc5e73030.9f881d44cf0ad",
    "filename": "wBdJJf8NHqV",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "John K. - Leveraging Martial Arts Experience for His Own Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.b64f5ab15e56c0.6ce8188a5e976",
    "filename": "Ddm6dNrgHBP",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Callie - Turning Experience into a Consulting ERS Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f557105fe07e50.201f5f7340368",
    "filename": "jL6oe8eYBFd",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Ryan T. - College Admissions Mentor",
    "date": "",
    "description": ""
  },
  {
    "id": "0.c0af4a2bcedf50.bf0a74bf74231",
    "filename": "LSog86wT72C",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Michael Z. - Leveraging Graphic Design Skills",
    "date": "",
    "description": ""
  },
  {
    "id": "0.adf8aba4bb5590.164b6a0973788",
    "filename": "b8QGZHpUXMV",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Antonio B. - Homeschooling & Unschooling",
    "date": "",
    "description": ""
  },
  {
    "id": "0.57827bd863cf50.95c36da814b91",
    "filename": "pBHWbjeBUbF",
    "tags": [
      "idea",
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Andrew - Using Personal Experience to Start a Platform",
    "date": "",
    "description": ""
  },
  {
    "id": "0.85597c8e3017f0.8b74b337dd54f",
    "filename": "2Y6vr1PuX7T",
    "tags": [
      "idea"
    ],
    "type": "weekly-build",
    "title": "Kylan + Real Estate Media Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.02289c180aa920.d15566b0121a6",
    "filename": "FEBTxq8PyuO",
    "tags": [
      "ecommerce",
      "influencer",
      "financial independence"
    ],
    "type": "weekly-idea",
    "title": "Isabel - Life after FI",
    "date": "",
    "description": ""
  },
  {
    "id": "0.abe3aef13c7ba0.69107c274d122",
    "filename": "GefDTeZvDdq",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Maxym - Solar Panel Service in Canada",
    "date": "",
    "description": ""
  },
  {
    "id": "0.05c8258e772c70.cfc705463ed5",
    "filename": "M21LYBcnM6L",
    "tags": [
      "scale",
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "John + Follow the Child (Amazon FBA)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.bfd466ebb64620.6bbf3c3758cf7",
    "filename": "Kk33KQDrbDT",
    "tags": [
      "blogging",
      "idea",
      "influencer"
    ],
    "type": "weekly-idea",
    "title": "Lindsay - Building a Niche Community",
    "date": "",
    "description": ""
  },
  {
    "id": "0.492c369becaa90.5d1e4ef1a1dad",
    "filename": "6BukYdfaiQa",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Brady + Bubba Bubble (Update)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.5e669a94a9d1e0.5fce70b96d4ae",
    "filename": "aK3eqRq6LPF",
    "tags": [
      "scale"
    ],
    "type": "weekly-idea",
    "title": "Rachael + Generational Health Platform",
    "date": "",
    "description": ""
  },
  {
    "id": "0.76d712eefff0.0caef84b6f1d1",
    "filename": "RKX4F5SeqpP",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Alex - Capitalizing on Trends (Pickleball)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.3f53d88a541e20.e3f78fa0156d2",
    "filename": "rAVHM5LKUrV",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "FIpreneur Community Orientation",
    "date": "",
    "description": ""
  },
  {
    "id": "0.52c2211ccc30b0.8decd079b24c9",
    "filename": "ptbfVrXdGxS",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Gary H. - Starting a Local Travel Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "0.92f2ce9bb8a090.654cacf4a57b7",
    "filename": "eX0l0LUvKZJ",
    "tags": [
      "blogging"
    ],
    "type": "video-vault",
    "title": "Validating a Blog Idea",
    "date": "",
    "description": ""
  },
  {
    "id": "amaznpackaging",
    "filename": "dX6kdY1jyxl",
    "tags": [
      "build"
    ],
    "type": "video-vault",
    "title": "Designing Packaging",
    "date": "",
    "description": ""
  },
  {
    "id": "0.3fe54b90b6a470.dfa0830a12926",
    "filename": "7ujqgKU3sdU",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Overcoming Analysis Paralysis",
    "date": "",
    "description": ""
  },
  {
    "id": "0.e35250062fd110.f5e8f5923471b",
    "filename": "AqIXJ8YaKgX",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "FIpreneur Mindset Series - The Slight Edge",
    "date": "",
    "description": ""
  },
  {
    "id": "outsource",
    "filename": "50703tpPhLS",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Leveraging Virtual Assistants",
    "date": "",
    "description": ""
  },
  {
    "id": "0.985c1d1dcd67d0.6eadca063228e",
    "filename": "eYXRajym3E3",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Engaging with your Mentor",
    "date": "",
    "description": ""
  },
  {
    "id": "paidads",
    "filename": "iY23LcGZSqM",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Assessing the Impact of Paid Ads",
    "date": "",
    "description": ""
  },
  {
    "id": "0.b4b7ec848c81f0.d1074a163a036",
    "filename": "jPq8bozTKf6",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Turn $100 into Earnings",
    "date": "",
    "description": ""
  },
  {
    "id": "0.886163dba3ef40.5237c816a39a9",
    "filename": "HKmdcNV0nPN",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "Claire's FIpreneur Journey",
    "date": "",
    "description": ""
  },
  {
    "id": "0.080b79a4bb7ea0.53ea2a13ad6d7",
    "filename": "IRWVB0P0reQ",
    "tags": [
      "ecommerce",
      "idea",
      "validate"
    ],
    "type": "weekly-idea",
    "title": "Amazon FBA Private Labeling vs Novel Products",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4cd2262e66b0f0.9b1685085d0d7",
    "filename": "eHoxoKqGoZJ",
    "tags": [
      "scale"
    ],
    "type": "weekly-idea",
    "title": "Unlocking Local Growth",
    "date": "",
    "description": ""
  },
  {
    "id": "0.c68afe229c6d80.c1654f39f235d",
    "filename": "sdj7VrGWMYr",
    "tags": [
      "idea",
      "ecommerce",
      "financial independence"
    ],
    "type": "weekly-idea",
    "title": "Prioritizing Interests",
    "date": "",
    "description": ""
  },
  {
    "id": "0.1195802cf465e0.4ee7a53c2e04a",
    "filename": "t4BEwrylCkD",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Deciding when to leave FT income",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4fdb602152d530.b150e560d841e",
    "filename": "Gls1g2lLLAz",
    "tags": [
      "idea"
    ],
    "type": "weekly-build",
    "title": "Brady + Bubba Bubble",
    "date": "",
    "description": ""
  },
  {
    "id": "0.8d62e6e7d23990.38825209609f6",
    "filename": "kfra4JMaYWl",
    "tags": [
      "ecommerce",
      "scale"
    ],
    "type": "weekly-build",
    "title": "Long-tail Keywords (Goated!)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.3c45b3134aba0.0c01da118c72c",
    "filename": "wJ9OXBB5v4Q",
    "tags": [
      "scale",
      "financial independence"
    ],
    "type": "video-vault",
    "title": "How Grant Transitioned Millennial Money into a Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4d12e6faad2fb0.743d726a5cdc3",
    "filename": "aW807JVvDTV",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "What strategies does Grant Use?",
    "date": "",
    "description": ""
  },
  {
    "id": "0.b4b1591b3da20.1c4759b996254",
    "filename": "RqGyYty4DPK",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "How to deal with failures?",
    "date": "",
    "description": ""
  },
  {
    "id": "0.5f5c0bef54be60.472acc08637f8",
    "filename": "iGgSwPOWoMb",
    "tags": [
      ""
    ],
    "type": "video-vault",
    "title": "How to stay accountable",
    "date": "",
    "description": ""
  },
  {
    "id": "0.f7abc1dfba1420.c06972e1d04e9",
    "filename": "MbBYRplQCM9",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Create more freedom in your life",
    "date": "",
    "description": ""
  },
  {
    "id": "0.2676502369f190.5474f564d7494",
    "filename": "XfbkjpGK9Zk",
    "tags": [
      "idea"
    ],
    "type": "weekly-build",
    "title": "Kathy + Bookkeeping",
    "date": "",
    "description": ""
  },
  {
    "id": "0.46078a680a2c70.77acbccbbf95d",
    "filename": "GiRYlJfZ2QO",
    "tags": [
      "financial independence"
    ],
    "type": "video-vault",
    "title": "Leaving 9-5 after reaching CashFlow FI",
    "date": "",
    "description": ""
  },
  {
    "id": "0.db9fbfd4692370.723c75bc1e411",
    "filename": "R6eoXazmuQz",
    "tags": [
      "financial independence",
      "validate"
    ],
    "type": "video-vault",
    "title": "Not dwelling on the negative when validating a side business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.9f8ec86c5aad90.06bb2fd613c9f",
    "filename": "oVA32RllR4i",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Marketing on a Budget",
    "date": "",
    "description": ""
  },
  {
    "id": "0.ca5434a6c33f0.1c82cda0db612",
    "filename": "haeOsmano7o",
    "tags": [
      "scale"
    ],
    "type": "video-vault",
    "title": "Alleviating Anxiety in Business",
    "date": "",
    "description": ""
  },
  {
    "id": "0.feb07e50cdd870.e0e46405ad4da",
    "filename": "p4xgzHwmZIA",
    "tags": [
      "idea"
    ],
    "type": "video-vault",
    "title": "Grants thoughts: Emerging Trends",
    "date": "",
    "description": ""
  },
  {
    "id": "0.6327c2fae7af70.5626efabca115",
    "filename": "e9BkgTeA7dk",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Alexa Brainstorms Idea with Grant (2nd call)",
    "date": "",
    "description": ""
  },
  {
    "id": "0.2259842eb167d0.049576e1d44ea",
    "filename": "yjEhqgN5I3D",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Nate - Recent Grad - Getting into the Fitness Industry",
    "date": "",
    "description": ""
  },
  {
    "id": "0.c65271c13d20d0.232483c3c7cb6",
    "filename": "EGflJWZa2ub",
    "tags": [
      "idea",
      "blogging"
    ],
    "type": "weekly-idea",
    "title": "Yemi - Midlife Money Blog Idea",
    "date": "",
    "description": ""
  },
  {
    "id": "0.4383094deb13f0.1616c4ed62fc4",
    "filename": "HrMwuvMbPiP",
    "tags": [
      "idea"
    ],
    "type": "weekly-idea",
    "title": "Alexa Finds an Idea with Grant",
    "date": "",
    "description": ""
  },
  {
    "id": "0.632bd054ea24f0.b2155f71bc214",
    "filename": "f45ZbopE7aM",
    "tags": [
      "influencer",
      "scale"
    ],
    "type": "weekly-build",
    "title": "Logan + Summer Boat Rental in Corfu",
    "date": "",
    "description": ""
  },
  {
    "id": "0.55eaeb09a81930.d296a26ad2cbf",
    "filename": "vN2uvv2YzaM",
    "tags": [
      "scale",
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "Matt R. - Behind the Scenes of Goated!",
    "date": "",
    "description": ""
  },
  {
    "id": "amaznidea",
    "filename": "2GgkhDrNjzd",
    "tags": [
      "idea",
      "ecommerce"
    ],
    "type": "weekly-idea",
    "title": "Becca - Cat Leggings (Amazon FBA)",
    "date": "",
    "description": ""
  },
  {
    "id": "diy2",
    "filename": "bk10PGnCDDR",
    "tags": [
      ""
    ],
    "type": "weekly-build",
    "title": "Grant helped boost Brady's sales from $20 to $750 a month",
    "date": "",
    "description": ""
  },
  {
    "id": "diy3",
    "filename": "0Axb3QG8A9W",
    "tags": [
      ""
    ],
    "type": "weekly-build",
    "title": "Grant Guided Jess to a $1M/Year Blogging Niche",
    "date": "",
    "description": ""
  },
  {
    "id": "0.5dd64db5548eb0.26d2d95324e27",
    "filename": "YF0UMbJ7wcV",
    "tags": [
      "scale",
      "blogging"
    ],
    "type": "weekly-build",
    "title": "Grant's Gives Claire the Framework to Start Monetizing Her Blog",
    "date": "",
    "description": ""
  },
  {
    "id": "0.d9759f44e26c50.3b703189ae10f",
    "filename": "nBGS90EnH97",
    "tags": [
      "idea",
      "ecommerce"
    ],
    "type": "weekly-idea",
    "title": "Andy + Compression Leggings (Amazon FBA)",
    "date": "3/18/2024",
    "description": ""
  },
  {
    "id": "0.1cbf57fd751070.382d3a3fc49f5",
    "filename": "ZOEpxq90P9M",
    "tags": [
      "idea",
      "ecommerce"
    ],
    "type": "weekly-build",
    "title": "David + Travel Lumbar Pillow - Brandbuilding (Amazon FBA)",
    "date": "3/20/2024",
    "description": ""
  }
]